<template>
	<section>
		<div v-if="showParentView('page-company')">
			<header-page
				name="companies"
				:title="$route.meta.title"
			/>
			<company-list
				:codeProject="codeProject"
				:columns="columns"
				:current-page="currentPage"
				:rows="table.rows"
				:last-page="table.lastPage"
				:search-value="params.search || ''"
				@change-page="changePage"
				@on-search="onSearch($event, `project/${codeProject}/companies`)"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
	import quickActions from '@/components/shared/quick-actions';
	import companyList from '@/components/companies/company-list';

	function created() {
		if (this.$route.name === 'page-company') {
			this.loadData(`project/${this.codeProject}/companies`);
		}
	}

	function changePage(page) {
		this.params.page = page;
		this.currentPage = page;
		this.loadData(`project/${this.codeProject}/companies`);
	}

	function openModal() {
		const codeProject = this.codeProject;
		this.goTo('page-new-company', { params: { codeProject } });
	}

	function data() {
		return {
			actions: [
				{
					id: 1,
					code: 'CC',
					text: 'Crear Compañía',
					icon: 'business',
					active: true,
				},
			],
			columns: [
				{ id: 1, name: 'Compañía', checked: true, visible: true },
				{ id: 2, name: 'Código', checked: true, visible: true },
				{ id: 3, name: 'RUC', checked: true, visible: true },
				{ id: 4, name: 'Configuración', checked: true, visible: true },
				{ id: 5, name: 'Plan', checked: true, visible: true },
				{ id: 6, name: 'Idiomas', checked: true, visible: true },
				{ id: 7, name: 'Servicios', checked: true, visible: true },
				{ id: 8, name: 'Actualización', checked: true, visible: true },
				{ id: 9, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			currentPage: 1,
		};
	}

	export default {
		name: 'page-company',
		components: {
			companyList,
			quickActions,
		},
		created,
		data,
		methods: {
			changePage,
			openModal,
		},
		props: {
			codeProject: {
				type: String,
			},
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'page-company') {
						this.loadData(`project/${this.codeProject}/companies`);
					}
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/companies/page-company.vue